import { render, staticRenderFns } from "./webhooks.vue?vue&type=template&id=95b171d6&scoped=true"
import script from "./webhooks.vue?vue&type=script&lang=js"
export * from "./webhooks.vue?vue&type=script&lang=js"
import style0 from "./webhooks.vue?vue&type=style&index=0&id=95b171d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b171d6",
  null
  
)

export default component.exports